export interface UserType {
  id: number;
  login: string;
  pass?: string;
  name?: string;
  email?: string;
  phone?: string;
  olevel?: number;
  ts?: string;
  is_active?: string;
  role?: RolesEnum;
  key?: React.Key;
  zones: ZoneType[];
}

export interface ZoneType {
  id?: number;
  domain: string;
  type?: ZoneTypes;
  zone?: NetworkType;
  key?: React.Key;
}

export enum ZoneTypes {
  all = 0,
  network = 2,
  addresses = 3,
}

export enum RolesEnum {
  owner = "OWNER",
  admin = "ADMIN",
  engineer = "ENGINEER",
  viewer = "VIEWER",
}

// export enum Roles {
//   all = 0,
//   network = 2,
//   addresses = 3,
// }

export interface ChangeNthZoneType {
  index: number;
  key: keyof ZoneType;
  value: string | ZoneTypes | NetworkType;
}

export interface NetworkType {
  id: number;
  networkId: number;
  networkDomain: string;
  networkLogin: string;
  networkName: string;
}

export interface NetworkOption {
  value: string;
  key: number;
  network: NetworkType;
}

export interface ZoneCfg {
  domain: string;
  all: boolean;
  networks: NetworkType[];
  addresses: boolean;
}
